function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionNeutralFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.005 16.005C2.005 8.287 8.283 2.009 16 2.009s13.995 6.278 13.995 13.995C29.995 23.722 23.718 30 16 30S2.005 23.722 2.005 16.005zm1.975 0c0 6.628 5.392 12.02 12.02 12.02 6.628 0 12.02-5.392 12.02-12.02 0-6.629-5.392-12.021-12.02-12.021-6.628 0-12.02 5.392-12.02 12.02z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.563 12.906a1.86 1.86 0 00-1.859-1.859 1.86 1.86 0 00-1.858 1.859 1.86 1.86 0 001.858 1.858 1.86 1.86 0 001.859-1.858zM21.296 11.047a1.86 1.86 0 00-1.859 1.859 1.86 1.86 0 001.858 1.858 1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.858-1.859zM21.533 19.844H10.556a.894.894 0 100 1.788h10.976a.894.894 0 000-1.788z",
    fill: props.color
  }));
}

export default SvgIconEmotionNeutralFilled;